/*
 * @Author: lidan
 * @Date: 2021-01-27 11:38:18
 * @LastEditTime: 2021-01-27 11:45:36
 * @LastEditors: lidan
 * @Description: 询价调度历史api
 * @FilePath: \e6-module-order-waybill-process\src\e6-module-order-waybill-process\api\dispatchHistory.js
 */
import http from "e6-base-core/axios/config";
import { e6ModuleOrderWaybillProcessApi } from "@/config/api";
const {
  host,
  E6_MS_TMS_BUSI_WEB,
  E6_MS_TMS_BASE_WEB
} = e6ModuleOrderWaybillProcessApi;

/* ************** 询价调度历史 **************** */
//询价调度历史列表
export function listInquiryInfo(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/inquiryInfo/list`,
    method: "post",
    data
  });
}

//询价调度历史状态数量统计
export function countInquiryInfo(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/inquiryInfo/count`,
    method: "post",
    data
  });
}

//选择参与者
export function joinList(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/inquiryInfo/joinList`,
    method: "post",
    data
  });
}

//取消调度
export function cancelDispatcher(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/inquiryInfo/cancelDispatcher`,
    method: "post",
    data
  });
}

//(下拉框)查询全部的承运商信息
export function findAllCarrierByPage(data) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/customerCarrier/findAllCarrierByPage`,
    method: "post",
    data
  });
}
